import gql from "graphql-tag";

export default gql`
  mutation createCertificate(
    $serial: String!
    $endDate: Float!
    $rfc: String!
    $type: CertificateType
    $cerFile: S3ObjectInput
    $keyFile: S3ObjectInput
    $keyPassword: String!
  ) {
    createCertificate(
      serial: $serial
      endDate: $endDate
      rfc: $rfc
      type: $type
      cerFile: $cerFile
      keyFile: $keyFile
      keyPassword: $keyPassword
    ) {
      userId
      serial
      id
      rfc
      endDate
      type
      createdAt
    }
  }
`;



// WEBPACK FOOTER //
// ./src/GraphQL/Mutation/UploadCertificate.js